<template>
  <div>
    <div class="quick-design-page">
      <div class="design-body">
        <template v-if="curr_mode === 'default'">
          <div class="design-color-size-quantity">
            <div class="top-title">Select color,size and quantity</div>
            <div class="style-box">
              <div class="label-box">
                <div class="type-label">Please select the style type</div>
                <div class="number-label">Custom Style Number</div>
                <div class="color-label">Color</div>
                <div class="size-label">Size</div>
                <div class="quantity-label">Quantity</div>
                <div class="price-label">Basic Price</div>
              </div>
              <div
                class="form-item"
                v-for="(item, index) in style_list"
                :key="index"
              >
                <div class="type-box">
                  <div class="type-item">
                    <select
                            size="large"
                            v-model="item.parent_product_category_id"
                            @change="
                        onChangeParentCategory(
                          $event.target.value,
                          item.parent_product_cate_list,
                          index
                        )
                      "
                    >
                      <option value="">Please select...</option>
                      <option
                              v-for="(v, k) in item.parent_product_cate_list"
                              :key="`dpc1` + k"
                              :value="v.product_category_id"
                      >
                        {{ v.category_name_en }}
                      </option>
                    </select>
                  </div>
                  <div
                          class="type-item"
                          v-show="item.sub_product_category_list.length > 0"
                  >
                    <select
                            v-model="item.child_product_category_id"
                            @change="
                        onChangeSubCategory(
                          $event.target.value,
                          item.sub_product_category_list,
                          index
                        )
                      "
                    >
                      <option value="">Please select...</option>
                      <option
                              v-for="(v, k) in item.sub_product_category_list"
                              :key="`dpc2` + k"
                              :value="v.product_category_id"
                      >
                        {{ v.category_name_en }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="number-box">
                  <input
                          @blur="onStyleNumberBlur($event.target.value, item, index)"
                          placeholder="Enter the style number..."
                          v-model="item.style_number"
                  />
                </div>
                <div class="color-box">
                  <input
                          placeholder="Enter the color..."
                          v-model="item.color"
                  />
                </div>
                <div class="size-box">
                  <select v-model="item.size" @change="onChangeSize">
                    <option value="">Please select...</option>
                    <option
                            v-for="(item, index) in item.size_list"
                            :key="index"
                            :value="item"
                    >
                      {{ item }}
                    </option>
                  </select>
                </div>
                <div class="quantity-box">
                  <input
                          type="number"
                          :min="1"
                          placeholder="Enter the quantity..."
                          v-model="item.quantity"
                  />
                </div>
                <div class="price-box">
                  {{ parseFloat(item.base_price * item.quantity) || 0 }}
                </div>
                <img
                        @click="onDeleteStyle(index)"
                        src="../../assets/images/icon-del.png"
                        alt=""
                        class="del-ico"
                />
              </div>
            </div>
            <div class="add-more-btn">
              <div class="more-btn" @click="onAddmoreStyle">
                <img
                        src="../../assets/images/icon-add-circle-blue.png"
                        alt=""
                        class="add-ico"
                />
                <div class="btn-text">Add more styles</div>
              </div>
            </div>
            <div class="note-info-title">Note Information</div>
            <div class="note-info-box">
              <div class="note-box">
                <textarea
                        v-model="remark"
                        placeholder="Please enter your special requests or any other information that needs to be noted..."
                ></textarea>
              </div>
            </div>

          </div>
          <div class="pick-address-box">
            <div class="pick-title">Add delivery or pickup address</div>

            <div class="address-list">
              <div
                      class="item-box"
                      v-for="(item, index) in address_list"
                      :key="index"
              >
                <input
                        type="radio"
                        :name="'address-radio-group'"
                        :checked="address_id == item.id"
                        @click.stop="address_id = item.id"
                />
                <div class="address-item" @click.stop="address_id = item.id">
                  <div class="name">
                    {{ `${item.title} ${item.first_name} ${item.last_name}` }}
                  </div>
                  <div class="address">
                    {{
                    `${item.address} ${item.address_alternate}, ${item.city},${item.state},${item.zip_code}  ${item.country}`
                    }}
                  </div>
                  <div class="phone">Phone number:{{ item.phone }}</div>
                  <div class="btn-box">
                    <div class="btn-item" @click.stop="edit_address(item)">
                      Edit Address
                    </div>
                    <div class="line"></div>
                    <div class="btn-item" @click.stop="del(item.id)">
                      Delete
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="add-btn" @click="is_popup_show = true">
              Add a new delivery address
            </div>
          </div>
          <div class="design-img-list">
            <div class="list-title">Style Design Draft</div>
            <div class="img-list">
              <div
                      class="img-item"
                      v-for="(item, index) in design.image_list"
                      :key="index"
              >
                <template v-if="util.test_image(item.raw)">
                  <img :src="item.raw" alt="" style="object-fit: cover" />
                </template>
                <template v-else>
                  <a :href="item.raw" target="_blank">
                    <img
                            :src="util.get_image_icon(item.raw)"
                            alt=""
                            style="object-fit: cover"
                    />
                  </a>
                </template>
                <img @click="deleteImage(index)" src="../../assets/images/icon-close-circle.png" alt="" class="remove-icon">
              </div>
              <!-- <div class="img-item"> -->
              <Upload
                      type="drag"
                      :action="upload_url"
                      :data="{ dir: 'template' }"
                      multiple
                      :before-upload="onBeforeUpload"
                      :show-upload-list="false"
              >
                <div class="upload-icon">
                  <img src="../../assets/images/icon-add-match-upload.png" />
                </div>
              </Upload>
              <!-- </div> -->
            </div>
          </div>
        </template>
        <template v-else-if="curr_mode === 'custom'">
          <div class="custom-order-details">
            <div class="detail-title">Custom Order Details</div>
            <table>
              <thead>
              <tr>
                <th>Style Classification</th>
                <th>Custom Style Number</th>
                <th>Color</th>
                <th>Size</th>
                <th>Quantity</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, index) in style_list" :key="index">
                <td>
                  {{
                  `${item.parent_cate_name} ${
                  item.child_cate_name ? "-" + item.child_cate_name : ""
                  }`
                  }}
                </td>
                <td>{{ item.style_number }}</td>
                <td>{{ item.color }}</td>
                <td>{{ item.size }}</td>
                <td>{{ item.quantity }}</td>
              </tr>
              </tbody>
            </table>
            <div class="detail-title">Style Design Draft</div>
            <div class="img-list">
              <div
                      class="img-item"
                      v-for="(item, index) in design.image_list"
                      :key="index"
              >
                <template v-if="util.test_image(item.raw)">
                  <img :src="item.raw" alt="" style="object-fit: cover" />
                </template>
                <template v-else>
                  <a :href="item.raw" target="_blank">
                    <img
                            :src="util.get_image_icon(item.raw)"
                            alt=""
                            style="object-fit: cover"
                    />
                  </a>
                </template>
              </div>
            </div>
            <div class="detail-title">Shipping Information</div>
            <div class="shipping-info">
              <div class="info-container">
                <div class="info-box">
                  <div class="name">
                    {{
                    `${select_address.title} ${select_address.first_name} ${select_address.last_name}`
                    }}
                  </div>
                  <div class="other">
                    {{
                    `${select_address.address} ${select_address.address_alternate}, ${select_address.city},${select_address.state},${select_address.zip_code}  ${select_address.country}`
                    }}
                  </div>
                  <div class="other">
                    Phone number:{{ select_address.phone }}
                  </div>
                </div>
                <div class="change-btn" @click="curr_mode = 'add-select'">
                  Change
                </div>
              </div>
            </div>
            <div class="detail-title">Note Information</div>
            <div class="note-info">
              <div class="info-container">
                {{ remark }}
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="curr_mode === 'add-select'">
          <div class="select-address">
            <div class="select-add-title">Select a delivery address</div>
            <div class="address-list">
              <div
                      class="item-box"
                      v-for="(item, index) in address_list"
                      :key="index"
              >
                <div style="display: flex; align-items: center">
                  <input
                          type="radio"
                          :name="'address-radio-group'"
                          :checked="address_id == item.id"
                          @click.stop="address_id = item.id"
                  />
                  <div class="address-item" @click.stop="address_id = item.id">
                    <div class="name">
                      {{ `${item.title} ${item.first_name} ${item.last_name}` }}
                    </div>
                    <div class="address">
                      {{
                      `${item.address} ${item.address_alternate}, ${item.city},${item.state},${item.zip_code}  ${item.country}`
                      }}
                    </div>
                    <div class="phone">Phone number:{{ item.phone }}</div>
                  </div>
                </div>
                <div class="btn-box">
                  <div class="btn-item" @click.stop="edit_address(item)">
                    Edit Address
                  </div>
                  <div class="line"></div>
                  <div class="btn-item" @click.stop="del(item.id)">Delete</div>
                </div>
              </div>
            </div>
            <div class="add-new-btn" @click="is_popup_show = true">
              Add a new delivery address
            </div>
            <div class="select-address-btn" @click="curr_mode = 'custom'">
              Deliver to this address
            </div>
          </div>
        </template>
      </div>
      <div class="footer" v-if="curr_mode != 'add-select'">
        <div class="footer-wrap">
          <div class="footer-btns">
            <div class="price-wrap">
              Quantity：×{{ count }}
              <span class="shu">|</span>
              Total production cost：
              <span class="money2">${{ total_price | price_format }}</span>
            </div>
            <div class="btn btn-back" @click="onCancelClick">{{curr_mode === 'default' ? 'Cancel' :'Return to Edit'}}</div>
            <div class="btn btn-confirm" @click="submit">
              {{curr_mode === 'default' ? 'Submit Customization' : 'Confirm and submit' }}
            </div>
          </div>
          <div class="footer-tips">
            Note: This fee only covers the basic production cost for the style. Additional charges will apply for services such as printing, embroidery, or special techniques, subject to confirmation by customer service. Please be advised accordingly!
          </div>
        </div>
      </div>
    </div>
    <!-- 添加地址弹窗 -->
    <popup
            :show.sync="is_popup_show"
            width="560px"
            height="850px"
            class="bg-white"
            @on-close="close"
    >
      <h2>
        {{
        form_address_data.id
        ? "Edit Shipping Address"
        : "Add Shipping Address"
        }}
      </h2>
      <Form
              class="address-form"
              ref="formValidate"
              :model="form_address_data"
              :rules="rules"
      >
        <div class="form-group">
          <FormItem prop="country" label="Country/region">
            <Select
                    v-model="form_address_data.country"
                    filterable
                    style="height: 40px"
            >
              <Option
                      :value="item.name"
                      :key="index"
                      v-for="(item, index) in countryList"
              >{{ item.name }}</Option
              >
            </Select>
          </FormItem>
        </div>

        <div class="form-group">
          <FormItem prop="title" label="Title (optional)" style="width: 245px">
            <Select v-model="form_address_data.title" style="height: 40px">
              <Option value="Mr">Mr</Option>
              <Option value="Mrs">Mrs</Option>
              <Option value="Mrs">Miss</Option>
              <Option value="Ms">Ms</Option>
              <Option value="Ms">Sir</Option>
            </Select>
          </FormItem>
        </div>
        <div class="form-group">
          <div class="flex align-center justify-between">
            <FormItem prop="first_name" label="First name">
              <Input
                      type="text"
                      class="input"
                      v-model="form_address_data.first_name"
                      style="width: 245px"
              />
            </FormItem>
            <FormItem prop="last_name" label="Last name">
              <Input
                      type="text"
                      class="input"
                      v-model="form_address_data.last_name"
                      style="width: 245px"
              />
            </FormItem>
          </div>
        </div>
        <div class="form-group">
          <FormItem prop="address" label="Address line one">
            <Input
                    type="text"
                    class="input"
                    v-model="form_address_data.address"
            />
          </FormItem>
        </div>
        <div class="form-group">
          <FormItem
                  prop="address_alternate"
                  label="Address line two (optional)"
          >
            <Input
                    type="text"
                    class="input"
                    v-model="form_address_data.address_alternate"
            />
          </FormItem>
        </div>
        <div class="form-group">
          <FormItem prop="city" label="City">
            <Input type="text" class="input" v-model="form_address_data.city" />
          </FormItem>
        </div>

        <div class="form-group">
          <div class="flex align-center justify-between">
            <FormItem prop="state" label="State" style="width: 245px">
              <Select v-model="form_address_data.state" style="height: 40px">
                <Option
                        :value="item.name"
                        :key="index"
                        v-for="(item, index) in stateList"
                >{{ item.name }}</Option
                >
              </Select>
            </FormItem>

            <FormItem prop="zip_code" label="ZIP code" style="width: 245px">
              <Input
                      type="text"
                      class="input"
                      v-model="form_address_data.zip_code"
              />
            </FormItem>
          </div>
        </div>
        <div class="form-group">
          <div class="flex align-center justify-between">
            <FormItem prop="phone" label="Phone number">
              <Input
                      type="text"
                      class="input"
                      v-model="form_address_data.phone"
                      style="width: 245px"
              />
            </FormItem>
            <FormItem
                    prop="phone_alternate"
                    label="Alternate number (optional)"
            >
              <Input
                      type="text"
                      class="input"
                      v-model="form_address_data.phone_alternate"
                      style="width: 245px"
              />
            </FormItem>
          </div>
        </div>
        <div class="flex align-center justify-center">
          <Button class="btn-submit" @click="saveAddress('formValidate')"
          >Save</Button
          >
        </div>
      </Form>
    </popup>

    <!-- 提交成功弹窗 -->
    <popup
            :show.sync="is_success_show"
            width="500px"
            height="350px"
            class="bg-white"
            :closeable="false"
            @on-close="is_success_show = false"
    >
      <div class="success-popup">
        <img
                src="../../assets/images/icon-success-free.png"
                alt=""
                class="success-icon"
        />
        <div class="success-title">Submission Successful</div>
        <div class="success-msg">
          Your clothing customization request has been submitted,and we will
          contact you as soon as possible to confirm the details.
        </div>
        <div class="success-btn" @click="onComplete">Complete</div>
      </div>
    </popup>
  </div>
</template>
<script>
import {
  AddressList,
  DeleteAddress,
  GetRegionList,
  SaveAddress,
} from "@/api";
import {
  CheckoutOrder,
  CreateOrder,
  GetDraft,
  ProductCategoryList,
  Profile,
  SaveDraft,
  updateImgList
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import { uploadFileToOSS } from "@/utils/oss";
import region from "@/utils/region.js";
import util from "@/utils/util.js";
import { driver } from 'driver.js';
import { mapState } from "vuex";
  export default {
    components: {
      Popup,
    },
    data() {
      return {
        util: util,
        uuid: "",
        sub_product_category_list: [],
        // 所有尺码数据
        raw_size_list: [],
        // 已选尺码KEY
        temp_size_ids: [],
        select_size_ids: [],
        design: {
          cost_list: [],
        },
        complete_list: [],
        table_data: [],
        is_choose_size: false,
        // 主面料A的颜色数据
        raw_color_list: [
          {
            color_id: -1,
            color_key: -1,
            color_name: "Default Color",
            color_name_en: "Default Color",
            color_value: "",
          },
        ],
        // 自定义颜色数据
        custom_color: [],
        temp_color_ids: [],
        // 已选颜色ID
        select_color_ids: [],
        is_add_color: false,
        from: "draft",
        // 仅来自草稿提交时有效
        new_style_no: "",
        is_detail_show: false,
        is_click: false,
        region: region,
        form_data_multiple: [],
        color_list_multiple: [],
        style_list: [],
        remark: "",
        uuids: [],
        address_id: "",
        is_popup_show: false,
        value: [],
        address_list: [],
        form_address_data: {
          id: 0,
          country: "",
          title: "",
          first_name: "",
          last_name: "",
          state: "",
          address: "",
          address_alternate: "",
          city: "",
          zip_code: "",
          phone: "",
          phone_alternate: "",
          is_default: 0,
        },
        rules: {
          country: [
            {
              required: true,
              message: "Country/region is required",
              trigger: "change",
            },
          ],
          first_name: [
            {
              required: true,
              message: "First name is required",
              trigger: "blur",
            },
          ],
          last_name: [
            {
              required: true,
              message: "Last name is required",
              trigger: "blur",
            },
          ],
          address: [
            {
              required: true,
              message: "Address line one is required",
              trigger: "blur",
            },
          ],
          city: [
            {
              required: true,
              message: "City is required",
              trigger: "blur",
            },
          ],
          zip_code: [
            {
              required: true,
              message: "ZIP code is required",
              trigger: "blur",
            },
          ],
          state: [
            {
              required: true,
              message: "State is required",
              trigger: "blur",
            },
          ],
          phone: [
            {
              required: true,
              message: "Phone number is required",
              trigger: "blur",
            },
          ],
        },
        countryList: [],
        stateList: [],
        select_address: {},
        curr_mode: "default",
        is_success_show: false,
        upload_url: process.uniEnv.BASE_API + "/util/upload-image",
        uploading: false,
        uploadQueue: [],
        debounceTimer: null, // 防抖定时器
        debounceTime: 300, // 防抖时间（毫秒）
      };
    },
    watch: {
      address_id(news, olds) {
        if (news != olds) {
          this.select_address = this.address_list.filter((item) => {
            return item.id == news;
          })[0];
        }
      },
      "form_address_data.country": function (e) {
        this.getStateList();
      },
      "form_data.parent_product_category_id": {
        handler(newVal, oldVal) {
          console.log("base", newVal, oldVal);
          if (newVal > 0) {
            let obj = this.product_category_list.find(
                    (v) => v.product_category_id === newVal
            );
            this.sub_product_category_list = obj ? obj.children : [];
            if (oldVal > 0) {
              this.$store.commit("design/update_common", {
                key: "child_product_category_id",
                value: 0,
              });
            }
          }
        },
        immediate: true, // 立即执行一次handler以初始化数据
      },
    },
    computed: {
      ...mapState({
        form_data: (state) => state.design.form_data,
        product_category_list: (state) => state.design.product_category_list,
      }),
      available_color_list() {
        let arr = this.raw_color_list.filter((v) =>
                this.select_color_ids.includes(v.color_id)
        );
        for (let i in this.custom_color.filter((v) =>
                this.select_color_ids.includes(v.color_id)
        )) {
          arr.push(this.custom_color[i]);
        }

        return arr;
      },
      total_price() {
        if (!this.style_list.length) {
          return 0;
        }

        // 根据style_list中的base_price和quantity计算总价
        let totalPrice = 0;
        this.style_list.forEach((item) => {
          // 确保转换为数值类型进行计算
          const basePrice = parseFloat(item.base_price) || 0;
          const quantity = parseInt(item.quantity) || 0;
          totalPrice += basePrice * quantity;
        });

        console.log("total_price===>", totalPrice);
        return totalPrice;
      },
      count() {
        let res = 0;
        this.style_list.forEach(item=>{
          res += parseInt(item.quantity);
        })

        return res;
      },
    },
    async mounted() {
      const { uuid } = this.$route.query;
      if (uuid) {
        this.uuid = uuid;
      }
      await this.getProductCategoryList()
      await Promise.all([
        this.onGetDraft(),
        this.getList(),
        this.getCountryList()
      ])

      if(!localStorage.getItem('qcuick_design_guide')){
          this.$nextTick(()=>{
          //  this.startGuide();
          })
          // localStorage.setItem('qcuick_design_guide',1);
      }
      // const { parent_product_category_id, child_product_category_id } =
      //   this.form_data;
      // let find_index_parent = this.product_category_list.findIndex(
      //   (v) => v.product_category_id == parent_product_category_id
      // );
      // if (find_index_parent != -1) {
      //   this.raw_size_list =
      //     this.product_category_list[find_index_parent].size_list;
      //   let s = this.raw_size_list[Math.floor(this.raw_size_list.length / 2)];
      //   console.log("parent_ssss", s);
      //   this.choose_size(s, false);
      // }
      // if (this.sub_product_category_list.length > 0) {
      //   let find_index_child = this.sub_product_category_list.findIndex(
      //     (v) => v.product_category_id == child_product_category_id
      //   );
      //   if (
      //     find_index_child != -1 &&
      //     this.sub_product_category_list[find_index_child].size_list.length > 0
      //   ) {
      //     this.raw_size_list =
      //       this.sub_product_category_list[find_index_child].size_list;
      //     let s = this.raw_size_list[Math.floor(this.raw_size_list.length / 2)];
      //     console.log("sub-sss", s);
      //     this.choose_size(s, false);
      //   }
      // }
      // this.temp_color_ids.push(-1);
      // this.select_color_ids.push(-1);
      // this.initTableData();
    },
    beforeRouteEnter(to, from, next) {
      next((vm) => {
        // 通过 `vm` 访问组件实例
        vm.$emit("showFooter", false);
      });
    },
    beforeRouteLeave(to, from, next) {
      this.$emit("showFooter", true);
      next();
    },
    methods: {
      startGuide(){
        if(!this.address_list.length){
                  //TODO 给地址列表演示数据
                  this.address_list = [
                    {
                      id: 1,
                      address: "Home",
                      address_alternate: "123 Main St, Anytown, CA 12345",
                      city:"City",
                      state:"State",
                      zip_code:"12345",
                      is_default: 1,
                      phone: "555-555-5555",
                      country: "United States",
                      title:"Mr./Ms.",
                      first_name:"First Name",
                      last_name:"Last Name"
                    }
                  ]
                }
        const guide = new driver({
            showProgress:true, //>显示步骤进度
            allowClose:false,   //>禁止点击外部关闭
            nextBtnText:"Next",
            prevBtnText:"Prev",
            doneBtnText:"Done",
            closeBtnText:"Close",
            steps:[
              {
                element:'.type-box',
                popover:{
                  title:"Style Type",
                  description: 'Choose the clothing category to customize',
                }
              },
              {
                element:'.number-box',
                popover:{
                  title:"Custom Style Number",
                  description: 'Enter your custom clothing style number',
                }
              },
              {
                element:'.color-box',
                popover:{
                  title:"Style Color",
                  description:"Enter the color of the clothing you want to customize",
                }
              },
              {
                element:'.size-box',
                popover:{
                  title:"Style Size",
                  description:"Choose the clothing size you want to customize",
                }
              },
              {
                element:'.quantity-box',
                popover:{
                  title:"Style Quantity",
                  description:"Enter the quantity of custom clothing you need"
                }
              },
              {
                element:".del-ico",
                popover:{
                  title:"Delete Style",
                  description:"Delete custom information for this line"
                }
              },
              {
                element:'.more-btn',
                popover:{
                  title:"Add More Style",
                  description:"Add customized clothing information"
                }
              },
              {
                element:'.note-box',
                popover:{
                  title:"Remarks",
                  description:"Enter your special requests or any other information that needs to be noted"
                }
              },
              {
                element:".address-item",
                popover:{
                  title:"Delivery Address",
                  description:"Choose your delivery address"
                }
              },
              {
                element:".add-btn",
                popover:{
                  title:"Add Address",
                  description:"Add your delivery address"
                }
              },
              {
                element:".remove-icon",
                popover:{
                  title:"Remove Design Draft",
                  description:"Remove your design draft"
                }
              },
              {
                element:".upload-icon",
                popover:{
                  title:"Upload Design Draft",
                  description:"Upload new or supplementary design drafts"
                }
              },
              {
                element:".btn-confirm",
                popover:{
                  title:"Submit And Confirm",
                  description:"Submit and confirm your customization"
                }
              }
            ],
            onDestroyed:()=>{
              //>引导结束,如果存在地址模拟数据,则清空并重新获取地址列表
              this.address_list = [];
              this.getList();
              localStorage.setItem('qcuick_design_guide',1);
              // console.log('aaa')
            }
        })
        //guide.drive();
      },
      validateStyleList() {
        // 检查style_list是否为空
        if (!this.style_list || this.style_list.length === 0) {
          return true;
        }

        // 遍历style_list中的每一项
        for (let i = 0; i < this.style_list.length; i++) {
          const item = this.style_list[i];

          // 检查每个必填字段是否为空
          if (
                  // 检查父级分类是否选择
                  !item.parent_product_category_id ||
                  // 检查样式编号是否填写
                  //!item.style_number ||
                  // 检查颜色是否填写
                  !item.color ||
                  // 检查尺寸是否选择
                  !item.size ||
                  // 检查数量是否填写且大于0
                  !item.quantity ||
                  parseInt(item.quantity) <= 0
          ) {
            return false;
          }

          // 如果有子分类列表且子分类列表不为空，检查是否选择了子分类
          if (
                  item.sub_product_category_list &&
                  item.sub_product_category_list.length > 0 &&
                  !item.child_product_category_id
          ) {
            return false;
          }
        }

        return true;
      },
      onCancelClick(){
        const {curr_mode} = this;
        if(curr_mode === 'default'){
          this.$router.back();
          return;
        }
        if(curr_mode === 'custom'){
          this.curr_mode = 'default';
          return;
        }
      },
      async onSave() {
        // TODO 保存,获取UUID,跳转新的SUMMARY
        try {
          if (this.is_click) {
            return;
          }
          this.is_click = true;
          console.log("form_data", this.form_data);
          if (!this.form_data.image_list.length) {
            this.$layer.msg("Please upload image or file");
            return;
          }
          // return;
          const { data } = await updateImgList({
            uuid:this.uuid,
            image_list:this.design.image_list
          });
          if (!data.uuid) {
            this.$layer.msg("Operation failed,please try again later");
            return;
          }
          this.$layer.msg("Operation successful");
        } catch (e) {
          console.log("e", e);
        } finally {
          this.is_click = false;
        }
      },
      deleteImage(index) {
        this.design.image_list.splice(index,1);
      },
      async processAllFiles() {
        const queue = [...this.uploadQueue];
        this.uploadQueue = []; // 清空队列

        console.log(`Startting upload ${queue.length} files...`);

        for (const file of queue) {
          try {
            const url = await uploadFileToOSS(file, "template");
            // this.image_list.push({raw:url,raw_name:file.name});
            const object = { raw: url, raw_name: file.name };
            this.design.image_list.push(object);
            console.log("image_list", this.design.image_list);
            // console.log('this.image_list',this.image_list);
          } catch (err) {
            this.$layer.msg(`上传失败：${file.name}`);
          }
        }
      },
      onBeforeUpload(file) {
        console.log("file-before", file);
        this.uploading = true;
        // 将文件加入队列
        this.uploadQueue.push(file);

        // 清除旧定时器
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }

        // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
        this.debounceTimer = setTimeout(() => {
          this.processAllFiles();
        }, this.debounceTime);
        return false;
      },
      onComplete() {
        this.is_success_show = false;
        this.$router.push({name:'OrderCenter'});
      },
      async getStateList() {
        let country = this.countryList.find(
                (i) => i.name == this.form_address_data.country
        );
        if (!country) {
          return;
        }
        GetRegionList({
          parent_id: country.country_id,
          type: 1,
        }).then((res) => {
          this.stateList = res.data;
        });
      },
      async getCountryList() {
        GetRegionList().then((res) => {
          this.countryList = res.data;
        });
      },
      saveAddress(name) {
        this.$refs[name].validate((valid) => {
          if (valid) {
            SaveAddress(this.form_address_data)
                    .then(() => {
                      this.$layer.msg(`Success`);
                      this.$refs[name].resetFields();
                      this.form_address_data = {
                        id: 0,
                        country: "",
                        title: "",
                        first_name: "",
                        last_name: "",
                        state: "",
                        address: "",
                        address_alternate: "",
                        city: "",
                        zip_code: "",
                        phone: "",
                        phone_alternate: "",
                        is_default: 0,
                      }
                      this.is_popup_show = false;
                    })
                    .finally(() => {
                      this.getList();
                    });
          }
        });
      },
      close() {
        this.is_popup_show = false;
      },
      edit_address(item) {
        this.form_address_data = item;
        this.is_popup_show = true;
      },
      del(id) {
        this.$DModal.confirm({
          content: "Are you sure you want to delete this address information",
          okText: "Confirm",
          cancelText: "Cancel",
          onOK: () => {
            DeleteAddress({ id })
                    .then(() => {
                      this.$layer.msg(`Success`);
                    })
                    .finally(() => {
                      this.getList();
                    });
          },
        });
      },
      async getList() {
        return AddressList().then((response) => {
          this.address_list = response.data;
          return response.data;
        });
      },
      onStyleNumberBlur(value, data, index) {
        console.log("style-number-value", value);
        console.log("style-number-data", data);
        console.log("style-number-index", index);
        const { uuid } = data;
        const check = this.style_list.filter((item) => {
          return item.uuid != uuid && item.style_number == value;
        });
        if (check && check.length > 0) {
          this.$layer.msg(
                  "Style number is a unique string,please check your data"
          );
          this.style_list[index].style_number = "";
          return;
        }
      },
      onDeleteStyle(index) {
        this.style_list.splice(index, 1);
        console.log("onDelete_style", this.style_list);
      },
      onChangeParentCategory(value, data, index) {
        console.log("value===>", value);
        console.log("data====>", data);
        console.log("index====>", index);
        const child = data.filter((item) => {
          return item.product_category_id == value;
        })[0];
        console.log("child==>", child);
        this.style_list[index].sub_product_category_list = [...child.children];
        this.style_list[index].size_list =[...new Set([...child.size_list_man, ...child.size_list_woman])];
        this.style_list[index].base_price = child.base_price_en;
        this.style_list[index].parent_cate_name = child.category_name_en;
      },
      onChangeSubCategory(value, data, index) {
        console.log("child-value===>", value);
        console.log("child-data====>", data);
        console.log("child-index====>", index);
        const res = data.filter((item) => {
          return item.product_category_id == value;
        })[0];
        console.log("resssss=>", res);
        this.style_list[index].size_list =[...new Set([...res.size_list_man, ...res.size_list_woman])];

        this.style_list[index].child_cate_name = res.category_name_en;
        if(res.base_price_en && res.base_price_en>0){
          this.style_list[index].base_price = res.base_price_en;
        }else{
          /**
           * 第一次选择的二级有base_price但是新的二级没有base_price
           * 需要重新从父级获取base_price
           */
          const parent = this.product_category_list.filter((item)=>{
            return item.product_category_id == res.parent_id;
          })[0];
          this.style_list[index].base_price = parent.base_price_en;
        }
      },
      onAddmoreStyle() {
        if(!this.validateStyleList()){
          this.$layer.msg("Please fill in all fields");
          return;
        }
        const uuid = util.uuid();
        console.log("style_list", this.style_list);
        this.style_list.push({
          uuid: uuid,
          style_number: "",
          color: "",
          size: "",
          quantity: 1,
          parent_product_cate_list: [...this.product_category_list],
          sub_product_category_list: [],
          size_list: [],
          parent_product_category_id: "",
          child_product_category_id: "",
          base_price: 0,
        });
      },
      onChangeSize(e) {
        console.log("e===>", e);
      },
      // initTableData() {
      //   // 确保默认颜色和尺寸都已正确初始化
      //   if (this.select_size_ids.length > 0 && this.select_color_ids.length > 0) {
      //     this.select_size_ids.forEach((sizeKey) => {
      //       if (!this.$_.has(this.table_data, sizeKey)) {
      //         this.choose_size(sizeKey, false);
      //       }
      //     });

      //     // 确保所有行都有所有颜色列
      //     this.ensureAllColorColumns();
      //   }
      // },
      async onGetDraft() {
        try {
          const { data } = await GetDraft({ uuid: this.$route.query.uuid });
          console.log("draft-data-mounted", data);
          this.design = data;
          this.remark = data.description;
          if(!data.children.length){
            this.onAddmoreStyle();
            return;
          }
          this.style_list = data.children.map((item)=>{
            let sub_cate = [];
            if (item.child_product_category_id) {
              sub_cate = this.product_category_list.filter((i) => {
                return i.product_category_id == item.parent_product_category_id;
              })[0]["children"];
            }
            let parent_cate = this.product_category_list.filter((i) => {
              return item.parent_product_category_id == i.product_category_id;
            })[0]
            let parent_size_list = []
            if (parent_cate) {
              parent_size_list = [...(Array.isArray(parent_cate.size_list_man) ? parent_cate.size_list_man : []),
              ...(Array.isArray(parent_cate.size_list_woman) ? parent_cate.size_list_woman : [])];
            }
            let child_size_list = [];
            if (sub_cate) {
              child_size_list = [...(Array.isArray(sub_cate.size_list_man) ? sub_cate.size_list_man : []),
              ...(Array.isArray(sub_cate.size_list_woman) ? sub_cate.size_list_woman : [])];
            }
            let local_data = {};
            if(this.style_list && this.style_list.length > 0){
              local_data = this.style_list.filter((i)=>{
                return i.style_number === item.name
              })[0]
            }
            return {
              uuid:item.key,
              parent_product_cate_list:[...this.product_category_list],
              sub_product_category_list:sub_cate && sub_cate.length>0 ? sub_cate :[],
              parent_product_category_id:item.parent_product_category_id,
              child_product_category_id:item.child_product_category_id,
              style_number:item.name,
              size_list:child_size_list.length>0 ? child_size_list : parent_size_list,
              quantity:local_data.quantity || 0,
              color:local_data.color || '',
              size:local_data.size || '',
              parent_cate_name: this.product_category_list.filter((i) => {
              return i.product_category_id == item.parent_product_category_id;
            })[0]["category_name_en"],
            child_cate_name: item.child_product_category_id
              ? sub_cate.filter((i) => {
                  return (
                    i.product_category_id == item.child_product_category_id
                  );
                })[0]["category_name_en"]
              : "",
              base_price: parseFloat(
                item.child_product_category_id
                  ? sub_cate && sub_cate.length > 0
                    ? sub_cate.filter((i) => {
                        return (
                          i.product_category_id == item.child_product_category_id
                        );
                      })[0]["base_price"] || 0
                    : 0
                  : this.product_category_list.filter((i) => {
                      return (
                        i.product_category_id == item.parent_product_category_id
                      );
                    })[0]["base_price"] || 0
              ),
            }
          })
        } catch (e) {
          console.log("e===>getDraft", e);
        }
      },
      async onUpdateInfo() {
        try {
          const img = this.design.image_list.filter((item)=>{
            const name = item.raw_name.split('.').pop();
            return ['jpg','jpeg','png','webp','gif'].includes(name);
          })[0];
          const { data } = await SaveDraft({
            uuid: this.uuid,
            scene: "bc",
            from:'fast',
            is_multiple:'1',
            image:img && img.raw ? img.raw : '',
            image_list: this.design.image_list,
            description:this.remark,
            children:this.style_list.map((item)=>{
              return {
                key:item.uuid,
                name:item.style_number,
                product_category_id:item.child_product_category_id ? item.child_product_category_id : item.parent_product_category_id,
                parent_product_category_id:item.parent_product_category_id,
                child_product_category_id:item.child_product_category_id,
                image_list:this.design.image_list,
                image:img && img.raw ? img.raw : ''
              }
            })
          });
          console.log("data===>", data);
          this.onGetDraft();
        } catch (e) {
          console.log("e--->save_draft", e);
        }
      },
      submit() {
        if (this.is_click) {
          return;
        }
        console.log("this.style_list", this.style_list);

        if(!this.design.image_list.length){
          this.$layer.msg('Please upload image or file');
          return;
        }

        if(!this.validateStyleList()){
          this.$layer.msg('Please fill the style info');
          return;
        }

        if(!this.style_list.length || this.style_list.length < 1){
          this.$layer.msg('Please add at least one style')
          return;
        }

        const img = this.design.image_list.filter((item)=>{
          const name = item.raw_name.split('.').pop();
          return ['jpg','jpeg','png','webp','gif'].includes(name);
        })[0];

        console.log('img',img);
        // console.log('img',img.raw);

        const data = {};
        const color = {};

        this.style_list.forEach((item) => {
          const color_uuid = util.uuid();

          // 确保 data[item.uuid] 存在
          if (!data[item.uuid]) {
            data[item.uuid] = {};
          }

          // 设置 category 信息
          data[item.uuid]["category"] = {
            product_category_id: item.child_product_category_id
                    ? item.child_product_category_id
                    : item.parent_product_category_id,
            parent_product_category_id: item.parent_product_category_id,
            child_product_category_id: item.child_product_category_id,
            name: item.style_number,
            image_list: this.design.image_list,
            key:item.uuid,
            image:img && img.raw ? img.raw : ''
          };

          // 确保 table_data 对象存在
          if (!data[item.uuid]["table_data"]) {
            data[item.uuid]["table_data"] = {};
          }

          // 确保特定尺寸的对象存在
          if (!data[item.uuid]["table_data"][item.size]) {
            data[item.uuid]["table_data"][item.size] = {};
          }

          // 设置 table_data 信息
          data[item.uuid]["table_data"][item.size] = {
            size: {
              size_key: item.size,
              size_alias: item.size,
            },
            color: {
              [color_uuid]: {
                color_id: color_uuid,
                color_key: color_uuid,
                color_name: item.color,
                color_name_en: item.color,
                quantity: item.quantity,
                type: 1,
                color_value: "",
              },
            },
            complete: {},
          };

          if (!data[item.uuid]["select_size_ids"]) {
            data[item.uuid]["select_size_ids"] = [];
          }

          data[item.uuid]["select_size_ids"].push(item.size);

          if (!data[item.uuid]["select_color_ids"]) {
            data[item.uuid]["select_color_ids"] = [];
          }

          data[item.uuid]["select_color_ids"].push(color_uuid);

          // 设置 color 信息
          if (!color[item.uuid]) {
            color[item.uuid] = {};
          }

          color[item.uuid] = [
            {
              color_id: color_uuid,
              color_key: color_uuid,
              color_name: item.color,
              color_name_en: item.color,
              color_value: "",
              type: 1,
            },
          ];
        });
        console.log("data", data);
        console.log("color", color);
        this.form_data_multiple = data;
        this.color_list_multiple = color;
        if(!this.address_id || this.address_id == '' || this.address_id == null || isNaN(this.address_id)){
          this.$layer.msg('Please choose the address');
          return;
        }
        // return;
        if (this.curr_mode === "default") {
          const param = {};
          param.from = "draft";
          param.uuid = this.uuid;
          param.form_data_multiple = data;
          param.color_list_multiple = color;
          console.log("param-before", param);
          this.curr_mode = "custom";
          this.onUpdateInfo();

          this.$nextTick(() => {
            window.scrollTo(0, 0);
          });
          return;
        }

        // return;
        if (this.count < 1) {
          this.$layer.msg(
                  `Please enter the quantity of customized clothing required`
          );
          return;
        }

        this.confirm_submit();
      },
      extractCategoryArray() {
        const categoryArray = [];

        // 遍历form_data_multiple对象
        for (const key in this.form_data_multiple) {
          if (this.form_data_multiple.hasOwnProperty(key) && this.form_data_multiple[key].category) {
            const category = this.form_data_multiple[key].category;
            categoryArray.push({
              parent_product_category_id: category.parent_product_category_id,
              child_product_category_id: category.child_product_category_id,
              product_category_id: category.product_category_id
            });
          }
        }

        return categoryArray;
      },
      async confirm_submit() {
        if(!this.address_id || String(this.address_id).trim() === '' || isNaN(this.address_id)){
          this.$layer.msg('Please choose the address');
          return;
        }
        const param = {};
        param.from = this.from;
        param.new_style_no = this.new_style_no;
        param.form_data_multiple = this.form_data_multiple,
                param.color_list_multiple = this.color_list_multiple,
                param.uuid = this.$route.query.uuid;
        param.sample_extra = this.form_data_sample;
        param.is_fast = 1;
        console.log("param", param);
        //   return;
        const product_category = this.extractCategoryArray();
        this.is_click = true;
        this.$Spin.show();
        CreateOrder(param).then((response) => {
          if(response.code > 0) {
            this.$layer.msg(response.msg)
            this.$Spin.hide();
            return
          }
          const {address_id} = this;
          const {uuid} = response.data;
          return CheckoutOrder({uuid,address_id,from:'fast',category:product_category})
        }).then((res)=>{
          this.$router.push({
            name: "CashDesk",
            query: { uuid: res.data.uuid, pay_type: "paypal",from:'quick' },
          });
          // return PayOrder({pay_type:'free',uuid: res.data.uuid})
        }).then(()=>{
          // this.is_success_show = true;
        }).catch((res) => {
          console.log('err', res)
          this.$layer.msg(res.msg);
        }).finally(() => {
          this.$Spin.hide();
          setTimeout(() => {
            this.is_click = false;
          }, 500);
        });
      },
      async getProfile() {
        return Profile().then((response) => {
          return response;
        });
      },
      show_detail() {
        this.is_detail_show = true;
      },
      blur($e, v) {
        let temp = $e.target.value;
        if (isNaN(temp)) {
          v.val = v.normal;
        }
        temp = parseFloat(temp);
        if (temp < parseFloat(v.normal) + parseFloat(v.min)) {
          v.val = parseFloat(v.normal) + parseFloat(v.min);
        }
        if (temp > parseFloat(v.normal) + parseFloat(v.max)) {
          v.val = parseFloat(v.normal) + parseFloat(v.max);
        }
        v.val = Math.round(v.val * 10) / 10;
      },
      onAddColor(e) {
        console.log("add-color", e.target.value);
        const id = util.uuid();
        const color = e.target.value;
        const checkRepeat = this.raw_color_list.findIndex(
                (item) => item.color_name == color
        );
        console.log("check===>", checkRepeat);
        if (checkRepeat != -1) {
          this.$layer.msg("This color has been added");
          return;
        }
        this.raw_color_list.push({
          color_id: id,
          color_key: id,
          color_name: color,
          color_name_en: color,
          color_value: "",
        });
        if (!this.temp_color_ids.includes(id)) {
          this.temp_color_ids.push(id);
          this.select_color_ids.push(id);
        }
        this.is_add_color = false;

        // 更新所有已存在的表格行，添加新颜色列
        for (let sizeKey in this.table_data) {
          let colorObj = this.available_color_list.find((v) => v.color_id === id);
          if (colorObj && !this.$_.has(this.table_data[sizeKey].color, id)) {
            this.$set(this.table_data[sizeKey].color, id, {
              ...colorObj,
              quantity: 0,
            });
          }
        }
        console.log("raw-color-list", this.raw_color_list);
        console.log("temp_color_ids", this.temp_color_ids);
        console.log("select_color_ids", this.select_color_ids);
      },
      choose_size(size_key, is_delete = true) {
        let shouldCreateRow = false;

        if (is_delete && this.select_size_ids.includes(size_key)) {
          this.select_size_ids = this.select_size_ids.filter((item) => {
            return item !== size_key;
          });
        } else {
          console.log("aaaa", size_key);
          if (!this.select_size_ids.includes(size_key)) {
            this.select_size_ids.push(size_key);
            this.select_size_ids = [...new Set(this.select_size_ids)];
            shouldCreateRow = true;
          }
        }

        console.log("this.select_size_ids", this.select_size_ids);
        let obj = this.table_data;

        if (is_delete && this.$_.has(obj, size_key)) {
          delete obj[`${size_key}`];
          this.$set(this, "table_data", obj);
        } else if (shouldCreateRow || !is_delete) {
          // 确保在非删除模式下也会创建行
          let temp_color = {};
          for (let ii in this.select_color_ids) {
            let color = this.available_color_list.find(
                    (v) => v.color_id === this.select_color_ids[ii]
            );
            temp_color[this.select_color_ids[ii]] = { ...color, quantity: 0 };
          }

          let temp_complete = this.$_.cloneDeep(
                  this.design?.pat?.size_info[size_key] || {}
          );
          if (this.design.pattern_type === 3) {
            // 定制版型情况
            temp_complete = this.$_.cloneDeep(
                    this.design?.productcategory?.size_info[size_key] || {}
            );
          }
          for (let i in temp_complete) {
            if (!this.$_.has(temp_complete[i], "val")) {
              temp_complete[i].val = temp_complete[i].normal;
            }
          }

          this.$set(
                  this.table_data,
                  size_key,
                  this.$_.cloneDeep({
                    size: { size_key: size_key, size_alias: size_key },
                    color: temp_color,
                    complete: temp_complete,
                    sort: this.raw_size_list.findIndex((v) => v === size_key),
                  })
          );
        }

        const map = new Map(
                Object.entries(this.table_data).sort(function (a, b) {
                  return a[1].sort - b[1].sort;
                })
        );
        this.$set(this, "table_data", Object.fromEntries(map));

        // 确保所有颜色列都正确显示
        this.ensureAllColorColumns();
      },
      ensureAllColorColumns() {
        // 确保 table_data 中的每一行都包含所有已选颜色
        for (let sizeKey in this.table_data) {
          let row = this.table_data[sizeKey];
          for (let i in this.select_color_ids) {
            let colorId = this.select_color_ids[i];
            if (!this.$_.has(row.color, colorId)) {
              let color = this.available_color_list.find(
                      (v) => v.color_id === colorId
              );
              if (color) {
                this.$set(row.color, colorId, { ...color, quantity: 0 });
              }
            }
          }
        }
      },
      change1($event, field) {
        switch (field) {
          case "parent_product_category_id": {
            const find_index = this.product_category_list.findIndex(
                    (item) =>
                            Number(item.product_category_id) === Number($event.target.value)
            );
            if (find_index != -1) {
              this.curr_package_detail =
                      this.product_category_list[find_index].package_detail || [];
              this.raw_size_list =
                      this.product_category_list[find_index].size_list;
              let s =
                      this.raw_size_list[Math.floor(this.raw_size_list.length / 2)];
              this.choose_size(s);
              this.complete_list =
                      this.product_category_list[find_index].complete_list;
              this.$store.commit("design/update_common", {
                key: "package_detail",
                value: this.curr_package_detail,
              });
            }
            break;
          }
          case "child_product_category_id": {
            const find_index = this.sub_product_category_list.findIndex(
                    (item) =>
                            Number(item.product_category_id) === Number($event.target.value)
            );
            if (find_index != -1) {
              if (
                      this.sub_product_category_list[find_index].package_detail &&
                      this.sub_product_category_list[find_index].package_detail.length >
                      0
              ) {
                this.package_detail =
                        this.sub_product_category_list[find_index].package_detail;
                if (
                        this.sub_product_category_list[find_index].size_list.length > 0
                ) {
                  this.raw_size_list =
                          this.sub_product_category_list[find_index].size_list;
                  let s =
                          this.raw_size_list[Math.floor(this.raw_size_list.length / 2)];
                  this.choose_size(s);
                }
                if (
                        this.sub_product_category_list[find_index].complete_list
                                .length > 0
                ) {
                  this.complete_list =
                          this.sub_product_category_list[find_index].complete_list;
                }
                this.$store.commit("design/update_common", {
                  key: "package_detail",
                  value: this.curr_package_detail,
                });
              }
              // this.onUpdateInfo();
            }
            break;
          }
        }

        console.log("raw-size-list", this.raw_size_list);
        this.$store.commit("design/update_common", {
          key: field,
          value: parseInt($event.target.value),
        });

        // this.onUpdateInfo();
      },
      async getProductCategoryList() {
        const { data } = await ProductCategoryList();
        this.$store.commit("design/set_product_category_list", data);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .quick-design-page {
    width: 100%;
    min-height: 100vh;
    background: rgb(245, 246, 245);
    // padding-bottom:200px;
    // margin-bottom:200px;
    display: flex;
    justify-content: center;
    .design-body {
      width: 100%;
      max-width: 1200px;
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      margin-top: 8px;
      .design-color-size-quantity {
        width: 100%;
        background: #ffffff;
        padding: 30px 40px 50px 30px;
        .top-title {
          width: 100%;
          color: #333333;
          font-size: 20px;
          font-weight: bold;
          padding-bottom: 18px;
          border-bottom: 1px solid #ebebeb;
        }
        .style-box {
          width: 100%;
          margin-top: 25px;
          display: flex;
          align-items: center;
          flex-direction: column;
          row-gap: 8px;
          // column-gap: 10px;
          .label-box {
            display: flex;
            align-items: center;
            width: 100%;
            font-weight: bold;
            font-size: 14px;
            padding: 0 10px;
            column-gap: 10px;
            .type-label {
              width: 100%;
              max-width: 340px;
            }
            .number-label {
              width: 100%;
              max-width: 190px;
            }
            .color-label {
              width: 100%;
              max-width: 170px;
            }
            .size-label {
              width: 100%;
              max-width: 170px;
            }
            .quantity-label {
              width: 100%;
              max-width: 150px;
            }
            .price-label {
              width: 100%;
              max-width: 150px;
            }
          }
          .form-item {
            width: 100%;
            background: #fafafa;
            display: flex;
            align-items: center;
            column-gap: 10px;
            padding: 15px 10px;
            margin-top: 10px;
            .type-box,
            .number-box,
            .color-box,
            .size-box,
            .quantity-box{
              border: 1px solid #dad5d1;
              background: #ffffff;
              height: 52px;
              border-radius: 5px;
              width: 100%;
              overflow: hidden;
              input {
                border: none;
                outline: none;
                width: 100%;
                height: 100%;
                padding: 0 5px;
              }
            }
            .type-box {
              max-width: 339px;
              display: flex;
              align-items: center;
              .type-item {
                flex: 1;
                height: 100%;
                &:first-child {
                  // border-right:1px solid #dad5d1;
                }
                &:last-child {
                  border-left: 1px solid #dad5d1;
                }
                padding: 0 18px;
                select {
                  width: 100%;
                  height: 100%;
                  border: none;
                  outline: none;
                }
              }
            }
            .number-box {
              max-width: 190px;
            }
            .color-box,
            .size-box {
              max-width: 170px;
            }
            .size-box {
              padding: 0 5px;
              select {
                border: none;
                outline: none;
                width: 100%;
                height: 100%;
              }
            }
            .quantity-box {
              max-width: 150px;
            }
            .price-box{
              width:100%;
              max-width:150px;
              height:52px;
              line-height:52px;
              text-align:center;
            }
            .del-ico {
              width: 20px;
              height: 20px;
              cursor: pointer;
            }
          }
          .style-number {
            display: flex;
            flex-direction: column;
            row-gap: 10px;
            .label {
              color: #1a1a1a;
              font-size: 15px;
              font-weight: 500;
            }
            .input {
              width: 190px;
              height: 52px;
              border-radius: 5px;
              border: 1px solid #dad5d1;
              padding: 0 18px;
            }
          }
          .type-select {
            display: flex;
            flex-direction: column;
            row-gap: 10px;
            width: 100%;
            max-width: 340px;
            .label {
              color: #1a1a1a;
              font-size: 15px;
              font-weight: 500;
            }
            .input-box {
              display: flex;
              align-items: center;
              // column-gap: 5px;
              height: 52px;
              .select-item {
                flex: 1;
                height: 100%;
                border-radius: 5px;
                border: 1px solid #dad5d1;
                padding: 0 18px;
                select {
                  width: 100%;
                  height: 100%;
                  border: none;
                  outline: none;
                }
              }
            }
          }
        }
        .add-more-btn {
          width: 100%;
          border-bottom: 1px solid #e5e5e5;
          padding-bottom: 27px;
          margin-top: 20px;
          .more-btn {
            display: flex;
            align-items: center;
            column-gap: 8px;
            margin-left: 10px;
            width:fit-content;
            cursor: pointer;
            .add-ico {
              width: 18px;
              height: 18px;
            }
            .btn-text {
              font-size: 14px;
              color: #2162a1;
            }
          }
        }
        .note-info-title {
          width: 100%;
          margin-top: 25px;
          font-weight: bold;
          color: #333333;
          font-size: 14px;
          margin-left: 10px;
        }
        .note-info-box {
          width: 100%;
          padding: 13px 10px 0 10px;
          .note-box {
            width: 100%;
            height: 110px;
            border-radius: 5px;
            border: 1px solid #dad5d1;
            overflow: hidden;
            textarea {
              width: 100%;
              height: 100%;
              border: none;
              outline: none;
              padding: 10px;
            }
          }
        }

        .label-title {
          color: #1a1a1a;
          font-size: 15px;
          font-weight: 500;
          margin-top: 40px;
        }

        .table {
          width: 100%;
          margin-top: 10px;
          table-layout: fixed;
          text-align: center;
          border-collapse: collapse;
          display: block;
          overflow-x: auto;
          white-space: nowrap;
          border-right: 1px solid #e2e5e9;
          box-shadow: 2px 0 4px -1px rgba(0, 0, 0, 0.1);

          th,
          td {
            box-sizing: border-box;
          }

          th:first-child,
          td:first-child {
            position: sticky;
            left: 0;
            z-index: 10;
            background: #f8f8f9;
          }

          .size {
            width: 160px;
          }
          .color {
            width: 130px;
          }

          .complete {
            width: 130px;
          }
          .input {
            text-align: center;
            outline: none;
            border: 1px solid #e2e5e9;
            width: 100%;
          }

          th {
            padding: 0 5px;
            height: 50px;
            line-height: 50px;
            background: #f8f8f9;
            border: 1px solid #e2e5e9;

            &.color {
              color: #fa3d5a;
            }
            .icon-edit {
              width: 12px;
              height: 12px;
              margin: 0 10px;
            }
          }

          td {
            padding: 2px 5px;
            height: 50px;
            line-height: 50px;
            border: 1px solid #e2e5e9;
            font-size: 15px;
            .icon-edit {
              width: 12px;
              height: 12px;
              margin: 0 10px;
            }
          }
        }
      }
      .pick-address-box {
        width: 1200px;
        background: #ffffff;
        padding: 32px 40px 50px 40px;
        .pick-title {
          color: #333333;
          font-size: 20px;
          font-weight: bold;
          padding-bottom: 20px;
          border-bottom: 1px solid #e5e5e5;
        }
        .address-list {
          width: 100%;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          row-gap: 10px;

          .item-box {
            display: flex;
            align-items: center;
            // justify-content:space-between;
            padding-bottom: 27px;
            border-bottom: 1px solid #e5e5e5;
            margin-top: 30px;
            padding-right: 5%;
            flex: 1 0 50%;
            .address-item {
              display: flex;
              flex-direction: column;
              line-height: 1.5;
              // height:3em;
              margin-left: 10px;
              cursor: pointer;
              .name {
                color: #000000;
                font-size: 14px;
                font-weight: bolder;
              }
              .address,
              .phone {
                color: #333333;
                font-size: 14px;
                line-height:1.5;
                height:3em;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                /*! autoprefixer: ignore next */
                -webkit-box-orient: vertical;
                overflow: hidden;
                text-overflow: ellipsis;
                // max-height: 6em; /* 4行 * 1.5行高 = 6em */
                word-wrap:break-word;
                word-break:break-all;
              }
              .btn-box {
                display: flex;
                align-items: center;
                .btn-item {
                  color: #808080;
                  font-size: 12px;
                  cursor: pointer;
                  &:first-child {
                    padding-right: 15px;
                  }
                  &:last-child {
                    padding-left: 15px;
                  }
                  &:hover {
                    color: #2162a1;
                    text-decoration: underline;
                  }
                }
                .line {
                  width: 1px;
                  height: 15px;
                  background: #808080;
                }
              }
            }
          }
        }
        .add-btn {
          width: 280px;
          height: 52px;
          margin-top: 30px;
          border: 1px solid #dad5d1;
          border-radius: 26px;
          text-align: center;
          line-height: 52px;
          color: #1a1a1a;
          font-size: 14px;
          cursor: pointer;
        }
      }
      .design-img-list {
        width: 1200px;
        background: #ffffff;
        padding: 32px 40px 50px 40px;
        margin-bottom: 200px;
        .list-title {
          color: #333333;
          font-weight: bold;
          font-size: 20px;
          margin-bottom: 36px;
        }
        .img-list {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          .img-item {
            width: 150px;
            height: 150px;
            border: 1px solid #ebebeb;
            position:relative;
            img {
              width: 100%;
              height: 100%;
            }
            .remove-icon{
              width:22px;
              height:22px;
              position:absolute;
              top:5px;
              right:5px;
            }
          }
          .upload-icon{
            width:150px;
            height:150px;
            display:flex;
            align-items:center;
            justify-content:center;
            img{
              width:32px;
              height:32px;
            }
          }
        }
      }
      .custom-order-details {
        width: 100%;
        background: #ffffff;
        padding: 30px 40px 50px 30px;
        margin-bottom: 200px;
        .detail-title {
          color: #333333;
          font-size: 20px;
          font-weight: bold;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
          margin-bottom: 40px;

          th,
          td {
            border-right: none;
            border-left: none;
            border-top: 1px solid #e2e5e9;
            border-bottom: 1px solid #e2e5e9;
            padding: 12px 8px;
            text-align: left;
          }

          thead th {
            // background-color: #f8f8f9;
            color: #666666;
            font-size: 14px;
            text-align: left;
            font-weight: bold;
            border-top: none;
          }

          // 移除 tbody 中单元格的上边框，只保留下边框
          tbody td {
            border-top: none;
            text-align: left;
            color: #1a1a1a;
            font-size: 14px;
          }
        }
        .img-list {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 36px;
          margin-bottom: 50px;
          .img-item {
            width: 150px;
            height: 150px;
            border: 1px solid #ebebeb;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .shipping-info {
          width: 100%;
          background: #fafafa;
          margin-top: 20px;
          margin-bottom: 40px;
          .info-container {
            padding: 27px 20px;
            display: flex;
            justify-content: space-between;
            .info-box {
              display: flex;
              flex-direction: column;
              .name {
                color: #000000;
                font-size: 14px;
                font-weight: 500;
              }
              .other {
                color: #333333;
                font-size: 14px;
              }
            }
            .change-btn {
              color: #808080;
              font-size: 12px;
              cursor: pointer;
            }
          }
        }
        .note-info {
          width: 100%;
          background: #fafafa;
          margin-top: 20px;
          margin-bottom: 100px;
          .info-container {
            padding: 27px 20px;
            color: #333333;
            font-size: 14px;
          }
        }
      }
      .select-address {
        width: 100%;
        background: #ffffff;
        padding: 30px 40px 50px 30px;
        margin-bottom: 200px;
        .select-add-title {
          color: #333333;
          font-size: 20px;
          font-weight: bold;
          width: 100%;
          border-bottom: 1px solid #e5e5e5;
          padding-bottom: 20px;
        }
        .address-list {
          width: 100%;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          row-gap: 10px;

          .item-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 27px;
            border-bottom: 1px solid #e5e5e5;
            margin-top: 30px;
            width: 100%;
            .address-item {
              display: flex;
              flex-direction: column;
              line-height: 1.5;
              margin-left: 10px;
              cursor: pointer;
              .name {
                color: #000000;
                font-size: 14px;
                font-weight: bolder;
              }
              .address,
              .phone {
                color: #333333;
                font-size: 14px;
              }
            }
            .btn-box {
              display: flex;
              align-items: center;
              flex-wrap: nowrap;
              .btn-item {
                color: #808080;
                font-size: 12px;
                cursor: pointer;
                &:first-child {
                  padding-right: 15px;
                }
                &:last-child {
                  padding-left: 15px;
                }
                &:hover {
                  color: #2162a1;
                  text-decoration: underline;
                }
              }
              .line {
                width: 1px;
                height: 15px;
                background: #808080;
              }
            }
          }
        }
        .add-new-btn {
          color: #3872ab;
          font-size: 14px;
          margin-top: 30px;
          margin-left: 40px;
          cursor: pointer;
        }
        .select-address-btn {
          width: 320px;
          height: 52px;
          background: #222222;
          border-radius: 26px;
          color: #ffffff;
          line-height: 52px;
          text-align: center;
          margin-top: 80px;
          cursor: pointer;
        }
      }
    }
    .footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      height: 100px;
      background: white;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: center;
      z-index: 10;
      .footer-wrap{
        width:100%;
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:center;
        .footer-btns{
          display:flex;
          align-items:center;
          .price-wrap {
            color: #333333;
            font-size: 16px;
            position: relative;
            margin-right:10px;
            .shu {
              margin: 0 10px;
            }

            .money1 {
              color: #fa3d5a;
            }

            .money2 {
              color: #fa3d5a;
              font-weight: bold;
              font-size: 20px;
            }

            .btn-detail {
              color: #808080;
              margin: 0 35px;
              font-size: 14px;
              cursor: pointer;
            }

            .detail-modal {
              background: white;
              box-shadow: 0px 0px 20px 0px #a6a6a6;
              z-index: 100;
              position: absolute;
              bottom: 40px;
              right: 0;
              background: white;
              border-radius: 10px;
              padding: 15px;
              width: 240px;

              .p-list {
                .p-item {
                  display: flex;
                  justify-content: space-around;
                  font-size: 14px;
                  margin: 10px 0;

                  .left {
                    font-weight: bold;
                    width: 50%;
                  }

                  .right {
                    text-align: right;
                    width: 50%;
                    color: #fa3d5a;
                    font-weight: bold;
                  }
                }
              }
            }
          }

          .btn {
            height: 38px;
            line-height: 38px;
            border-radius: 19px;
            font-size: 14px;
            padding: 0 20px;
            cursor: pointer;

            &.btn-confirm {
              width: 200px;
              background: #fa3d5a;
              color: white;
              text-align: center;
            }

            &.btn-back {
              // width: 120px;
              margin-right: 20px;
              background: #ebebeb;
              color: #1c1f23;
              text-align: center;
            }
          }
        }
        .footer-tips{
          width:100%;
          text-align:center;
          font-size:12px;
          margin-top:10px;
          color:red;
        }
      }
    }
  }

  .address-form {
    padding: 30px 20px;
    .form-group {
      margin-bottom: 20px;
      ::v-deep .ivu-form-item-label {
        font-size: 14px;
        color: #212121;
        padding: 0px;
        margin-bottom: 5px;
      }
      ::v-deep .ivu-input {
        border-radius: 2px;
      }
      .input {
        //   width: 100%;
        //   height: 40px;
        //   line-height: 40px;
        //   padding: 0 10px;
        //   outline: none;
        //   background: #ffffff;
        border-radius: 2px;
        //   border: 1px solid #cbcbcb;
      }
    }
    .btn-submit {
      width: 220px;
      height: 40px;
      background: #0d0c22;
      border-radius: 2px;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      cursor: pointer;
    }
  }

  .success-popup {
    width: 100%;
    height: 100%;
    background: #ffffff;
    border-radius: 15px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .success-icon {
      width: 66px;
      height: 66px;
      margin-bottom: 30px;
    }
    .success-title {
      color: #333333;
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .success-msg {
      text-align: center;
      color: #333333;
      font-size: 14px;
      padding: 0 30px;
      margin-bottom: 58px;
    }
    .success-btn {
      width: 200px;
      height: 46px;
      border-radius: 6px;
      background: #fa3d5a;
      color: #ffffff;
      line-height: 46px;
      text-align: center;
      cursor: pointer;
    }
  }
</style>
